import { combineReducers } from 'redux'
import { user } from './user'
import { match } from './match'
import { numPlayers, onlinePlayers } from './numPlayers'
import { socket } from './socket'
import {question_game} from './questionGame'
import {userAnswer} from './userAnswer'
import { questions } from './questions'
import { currentQuestionId } from './currentQuestionId'
import { viewedQuestions } from './viewedQuestions'
import { questionsProviders } from './questionsProviders'
import { editQuestionId } from './editQuestionId'
import { answers } from './answers'
import { editAnswerId } from './editAnswerId'
import { matches } from './matches'
import { editMatchId } from './editMatchId'
import { chart } from './chart'
import { balance } from './balance'
import { newVersion } from './newVersion'
import { connected } from './connected'
import { live_video_url } from './liveVideoUrl'
import { betMs } from './betMs'
import { answerMs } from './answerMs'
import { currentToken } from './currentToken'
import { chatMessages } from './chatMessages'
import {bannedplayers} from './bannedplayers'
import {users} from './users'
import {bets} from './bets'
import {userPoints} from './userPoints'
import {videocall} from './videocall'
import {chat} from './chat'
import {autostream} from './autostream'
import {usersLimitNumber} from './usersLimitNumber'
import { snapshot } from './snapshot'

const blip = (state = null, action) => state

export default combineReducers({
    socket,
    user,
    numPlayers,
    onlinePlayers,
    questions,
    question_game,
    userAnswer,
    match,
    currentQuestionId,
    bannedplayers,
    viewedQuestions,
    questionsProviders,
    editQuestionId,
    answers,
    editAnswerId,
    matches,
    editMatchId,
    chart,
    balance,
    newVersion,
    connected,
    live_video_url,
    betMs,
    answerMs,
    currentToken,
    chatMessages,
    videocall,
    users,
    blip,
    bets,
    userPoints,
    chat,
    autostream,
    usersLimitNumber,
    snapshot,
    resetPasswordToken: (state = null) => state
})


// WEBPACK FOOTER //
// ./src/reducers/quizApp.js